import React from 'react';

import PropTypes from 'prop-types';

import { useLocale } from '@adsk/alloy-react-locale';
import Tooltip from '@adsk/alloy-react-tooltip';

import {
  StyledPackagesMissingEntities,
  StyledPackagesMissingEntitiesContent,
  StyledPackagesMissingEntitiesIcon,
  StyledPackagesMissingEntitiesMessage,
} from './PackagesMissingEntities.styles';

const PackagesMissingEntities = ({ count }) => {
  const { T } = useLocale(({ locale }) => require(`../i18n/${locale}.json`));

  return (
    <StyledPackagesMissingEntities>
      <Tooltip
        content={T.translate('MISSING_ENTITIES_TOOLTIP', { context: count })}
      >
        <StyledPackagesMissingEntitiesContent>
          <StyledPackagesMissingEntitiesIcon />
          <StyledPackagesMissingEntitiesMessage>
            {T.translate('MISSING_ENTITIES_MESSAGE', { context: count })}
          </StyledPackagesMissingEntitiesMessage>
        </StyledPackagesMissingEntitiesContent>
      </Tooltip>
    </StyledPackagesMissingEntities>
  );
};

PackagesMissingEntities.propTypes = {
  /** Number of missing entities */
  count: PropTypes.number.isRequired,
};

export default PackagesMissingEntities;
